import React from 'react';

import { NameInput } from './components/NameInput';
import { useNameInputWrapper } from './hooks/useNameInputWrapper';

type Props = {
	disabled: boolean;
};

export const NameInputWrapper: React.FC<Props> = ({ disabled }) => {
	const { data, actions } = useNameInputWrapper();
	return <NameInput {...data} {...actions} disabled={disabled} />;
};
